import React from "react";
import { Link } from "react-router-dom";

/** Renders a stored content array (nodes) as read-only JSX. */
export default function EntryRenderer({ content, highlightMentionId }) {
    return (
        <div className="scripture text-[17px] leading-[1.8] text-ink whitespace-pre-wrap break-words">
            {(content || []).map((node, i) => {
                if (node.type === "text") {
                    return <React.Fragment key={i}>{node.text}</React.Fragment>;
                }
                if (node.type === "mention") {
                    const isHi = highlightMentionId === node.node_id;
                    return (
                        <Link
                            key={i}
                            id={`node-${node.node_id}`}
                            data-testid={`mention-chip-${node.node_id}`}
                            to={`/prayer/${node.subject_id}`}
                            className={
                                "inline-flex items-center align-baseline px-2 py-0.5 mx-0.5 rounded-full font-ui text-[13px] font-medium text-plum bg-plum/10 hover:bg-plum/20 transition " +
                                (isHi ? "mention-highlight" : "")
                            }
                        >
                            @{node.name}
                        </Link>
                    );
                }
                if (node.type === "verse_card") {
                    return <VerseCard key={i} node={node} />;
                }
                return null;
            })}
        </div>
    );
}

function VerseCard({ node }) {
    // Multi-ref support: refs[] preferred; fallback to reference singular
    const refs = (node.refs && node.refs.length) ? node.refs : (node.reference ? [node.reference] : []);
    const first = refs[0] || "";
    const parts = first.split(".");
    const ch = Number(parts[1] || 0) || 1;
    const firstVerse = parts[2] ? Number(parts[2].split("-")[0]) : null;
    const target = `/?chapter=${ch}${firstVerse ? `&verse=${firstVerse}` : ""}`;
    const format = node.format || "full";

    return (
        <div className="my-2 rounded-lg border-l-4 border-moss bg-moss/5 pl-3 pr-3 py-2">
            <Link
                id={`node-${node.node_id}`}
                data-testid={`verse-card-${node.node_id}`}
                to={target}
                className="block hover:bg-moss/10 -mx-3 -my-2 pl-3 pr-3 py-2 rounded transition"
            >
                <div className="font-ui text-[10px] uppercase tracking-[0.2em] text-moss-deep font-semibold">
                    {node.label}
                    {node.translation ? ` · ${node.translation.toUpperCase()}` : ""}
                </div>
                {format === "full" && (
                    <div className="scripture text-[15px] text-ink mt-1 leading-snug">
                        {node.text}
                    </div>
                )}
            </Link>
            {refs.length > 1 && (
                <div className="mt-1.5 flex flex-wrap gap-1">
                    {refs.map(r => {
                        const rp = r.split(".");
                        const rc = Number(rp[1] || 0) || 1;
                        const rv = rp[2] ? Number(rp[2].split("-")[0]) : null;
                        return (
                            <Link
                                key={r}
                                data-testid={`verse-card-ref-${r}`}
                                to={`/?chapter=${rc}${rv ? `&verse=${rv}` : ""}`}
                                className="px-1.5 py-0.5 rounded bg-moss/10 text-moss-deep font-ui text-[10px] font-semibold hover:bg-moss/20 transition"
                            >
                                {rc}:{rv || ""}
                            </Link>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
